import React from 'react';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { routes } from '../../../constants';
import { PublishedEventTypes } from '../../../constants/publishedEvent';
import { publisherPortalActions } from '../../../state/modules/publisher-portal';
import { Icon } from '../../components';
import EventTable from './../shared/publish-event/event-table';

const CourseDashboard = ({ getEvents, deleteEvent, eventsResult, isFetchingEvents, isFetching, eventDetailsRoute, eventEditRoute }) => (
  <div className='base-layout'>
    <section id='header--publishers' className='layout--header'>
      <Grid>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Welcome to Caddie Courses for publishers</h1>
          </Col>
        </Row>
        <Row className='button-gutter'>
          <Col xs={12} md={6}>
            <h2>Reward your audience by attending industry courses</h2>
            <p>Caddie Courses help financial advisers access industry courses, with tracking capabilities for AFSLs. Add your course here and we’ll publish it in Caddie. You can also add quiz’s to demonstrate the level of understanding of the course, and we’ll track it in Caddie. It’s that easy!</p>
          </Col>
        </Row>
      </Grid>
    </section>
    <section id='section--publishers' className='layout--section'>
      <Grid>
        <section id='publishers--your-caddie-links' className='publishers--dashboard'>
          <Row className='xs-gutter mobile-boxed'>
            <Col xs={12} md={6}>
              <h2><Icon icon='caddie-links-large-alt' /> Your Courses</h2>
              <p>Add or manage Courses.</p>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer className='large full pull-down' to={routes.publisherPortal.courseDetails}>
                <Button>
                  <Icon icon='add-large' /> Add Course
                </Button>
              </LinkContainer>
            </Col>
            <Col xs={12} md={3}>
              <LinkContainer className='large full pull-down' to={routes.publisherPortal.courses}>
                <Button>
                  See all Courses <Icon icon='chevron-right-large' />
                </Button>
              </LinkContainer>
            </Col>
          </Row>
          <EventTable
            eventType={PublishedEventTypes.Course}
            eventsResult={eventsResult}
            isFetchingEvents={isFetchingEvents}
            isFetching={isFetching}
            eventEditRoute={eventEditRoute}
            getEvents={getEvents}
            deleteEvent={deleteEvent}
            eventsPerPage={6} />
        </section>
      </Grid>
    </section>
  </div>
)

const mapStateToProps = (state) => ({
  eventsResult: state.publisherPortal.events.eventsResult,
  isFetchingEvents: state.publisherPortal.events.isFetching,
  isFetching: state.cpdCategorys.isFetching ||
    state.publisherPortal.events.isFetching ||
    state.publisherPortal.events.isLoadingMore,
  eventDetailsRoute: routes.publisherPortal.courseDetails,
  eventEditRoute: routes.publisherPortal.courseEdit
});

const mapDispatchToProps = (dispatch) => ({
  getEvents: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.get, dispatch),
  deleteEvent: bindActionCreators(publisherPortalActions.publisherPortal.publishedEvent.deleteEvent, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(CourseDashboard);


// WEBPACK FOOTER //
// ./src/containers/pages/publisher-portal/course-dashboard.js